// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3HnND","right":"Footer_right__nYEKG","buttons":"Footer_buttons__2Z_DD"};